import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { SessionUserService } from '../services/session-user.service';

/**
 * Sends a signed-out visitor to the login screen, remembering where they were
 * going, so a shared session link opens the session after login.
 *
 * Without it the page loaded anyway, its API call was refused (401, which the
 * unauthorized interceptor deliberately ignores when nobody is signed in), and
 * the visitor was told the session does not exist.
 *
 * This is about getting the user signed in, not about access: the tracer
 * decides what each caller may see. After Keycloak brings the user back,
 * App.ngOnInit navigates to the saved URL. With auth disabled the session
 * service reports a signed-in operator, so this always lets through.
 */
export const requireLogin: CanActivateFn = (_route, state) => {
  if (inject(SessionUserService).authenticated) return true;
  inject(AuthService).saveRedirectedUrl(state.url);
  return inject(Router).parseUrl('/');
};
